import appManualInvoiceItem from "../../views/appSettings/manualInvoiceItemView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("manualinvoiceitem", {
    url: "manual-invoice-item/:id",
    parent: "app",
    views: {
      view: {
        template: appManualInvoiceItem,
      },
    },
    reloadOnSearch: false,
    data: { title: "ManualInvoiceItem" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItem/manualInvoiceItem.urls.js